import getApiClient from "./../../../../shared/api";

export const FETCH_BACKGROUND_CHARACTER_MAKEUPS = "FETCH_BACKGROUND_CHARACTER_MAKEUPS";

export function fetchBackgroundCharacterMakeups(filmId, characterId) {
  return (dispatch) => {
    dispatch({
      type: FETCH_BACKGROUND_CHARACTER_MAKEUPS,
      payload: getApiClient().get(`/film/${filmId}/backgroundCharacter/${characterId}/makeups`)
    });
  };
}
